export default {"src":"/_next/static/media/zencon_logo.bf35b33d.svg","height":47,"width":81};